<!-- Don't touch dividers that contains ids, cause they are used in unit test -->
<div class="container">
  Something
  <ui-divider id="divider" uiText="This is divider with text"></ui-divider>
  <p>Divider aligned on right</p>
  <ui-divider id="divider-text-orientation-right" uiText="Right" uiTextOrientation="right"></ui-divider>
  Without tekst
  <ui-divider></ui-divider>
  Plain text on the left side
  <ui-divider [uiDashed]="true" [uiPlain]="true" uiTextOrientation="left" uiText="Plain dashed"></ui-divider>
  left side of vertical <ui-divider id="divider-type-vertical" uiType="vertical"></ui-divider> right side of vertical
  <div>
    html element
    <ui-divider [uiText]="internalElement">
      <ng-template #internalElement>
        <ui-icon uiType="outline:poweroff"></ui-icon>
        Bye
      </ng-template>
    </ui-divider>
  </div>
</div>
